import _toUpper from 'lodash-es/toUpper';
import _forEach from 'lodash-es/forEach';

import { Component, EventEmitter, Input } from '@angular/core';

import { GenericField, IGenericField } from '../generic-field';

/**
 * Date-field
 * Generate date field with calendar
 * @extends GenericField
 * @implements IGenericField
 * @deprecated use chips-autocomplete instead
 */
@Component({

    selector: 'chips-field',
    templateUrl: './chips-field.html',
    styles: [`
        p-chipstab ::ng-deep .ui-chips-input-token input {
            height: auto;
            border: 0;
            padding: .5em .25em;
        }
    `],
    outputs: ['onRemove'],

})
export class ChipsFieldComponent extends GenericField implements IGenericField {
    public onRemove = new EventEmitter();

    @Input()
    public osmanClass: boolean;

    constructor() {
        super();
    }

    /**
     * addUpper
     * in uppercase when adding
     **/
    public addUpper(_e: any) {
        if (this.setMaj) {

            const ctrl = this.group.get(this.controlName);
            const tab = ctrl.value;

            const tab2: string[] = [];
            _forEach(tab, (val: string) => {
                tab2.push(_toUpper(val));
            });
            this.group.get(this.controlName).patchValue(tab2);
        }
    }

    public removeChip(chip): void {
        this.onRemove.emit(chip);
    }
}
